<template>
    <v-content>
      <v-container fluid>
      <v-alert v-if="error" :value="true" type="error">
        {{ error }}
      </v-alert>
        <GenericSingle
          :title="`Device Type`"
          :modelTitleField="`typename`"
          :childTitle="`Devices`"
          :previousPagePath="`/devicetypes`"
          :url="`/schemas/devicetypes`"
          :apiResponseField="`devicetype`"
          :reconcileURL="`/device/details?devicetype=`"
          :reconcileQueryField="`typename`"
          :infoTable="[
              {key: 'Name', value: 'typename'},
              {key: 'Description', value: 'description'},
            ]">
          <DeviceListTable :parentID="parseInt(this.$route.params.id)" v-on:error="errorHandler" />
        </GenericSingle>
      </v-container>
    </v-content>
</template>

<script>
import GenericSingle from '@/components/Common/GenericSingle'

import DeviceListTable from '@/components/Models/Device/ListTable'
export default {
  name: 'DeviceTypeSingle',
  components: { DeviceListTable, GenericSingle },
  data () {
    return {
      error: false
    }
  },
  methods: {
    errorHandler (error) {
      this.error = error
    }
  }
}
</script>

<style>
h1 .titleText {
  vertical-align: middle;
}
</style>
